/* Keep inactive carousels and drawers out of the keyboard tab order. */
(function () {
  'use strict';

  var focusableSelector = [
    'a[href]', 'area[href]', 'button:not([disabled])', 'input:not([disabled])',
    'select:not([disabled])', 'textarea:not([disabled])', 'iframe',
    '[contenteditable="true"]', '[tabindex]'
  ].join(',');

  function setHiddenDescendants(container, isHidden) {
    if (!container || container.nodeType !== 1) return;

    container.querySelectorAll(focusableSelector).forEach(function (element) {
      if (isHidden) {
        if (!element.hasAttribute('data-kalista-original-tabindex')) {
          element.setAttribute('data-kalista-original-tabindex', element.getAttribute('tabindex') || '');
        }
        element.setAttribute('tabindex', '-1');
        return;
      }

      if (!element.hasAttribute('data-kalista-original-tabindex')) return;
      var originalTabIndex = element.getAttribute('data-kalista-original-tabindex');
      if (originalTabIndex) {
        element.setAttribute('tabindex', originalTabIndex);
      } else {
        element.removeAttribute('tabindex');
      }
      element.removeAttribute('data-kalista-original-tabindex');
    });
  }

  function syncAriaHidden(container) {
    setHiddenDescendants(container, container.getAttribute('aria-hidden') === 'true');
  }

  function nameImageOverlayLinks(root) {
    var scope = root || document;
    var links = scope.querySelectorAll ? scope.querySelectorAll('a.link-over-image') : [];

    links.forEach(function (link) {
      var currentName = (link.getAttribute('aria-label') || link.textContent || '').trim();
      if (currentName) return;

      var image = link.parentElement && link.parentElement.querySelector('img[alt]');
      var fallback = link.pathname.split('/').filter(Boolean).pop() || 'collection';
      var label = image && image.alt ? image.alt : 'View ' + fallback.replace(/[-_]/g, ' ');
      link.setAttribute('aria-label', label);
    });
  }
  function normaliseFaqHeadings(root) {
    var scope = root || document;
    var headings = scope.querySelectorAll ? scope.querySelectorAll('h3, h4, h5, h6') : [];

    headings.forEach(function (heading) {
      var label = (heading.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label !== 'faqs' && label !== 'frequently asked questions') return;

      var replacementHeading = document.createElement('h2');
      Array.from(heading.attributes).forEach(function (attribute) {
        replacementHeading.setAttribute(attribute.name, attribute.value);
      });
      replacementHeading.innerHTML = heading.innerHTML;
      heading.replaceWith(replacementHeading);
    });
  }

  function initialiseAccessibility() {
    document.querySelectorAll('[aria-hidden="true"], [aria-hidden="false"]').forEach(syncAriaHidden);
    normaliseFaqHeadings(document);
    nameImageOverlayLinks(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          syncAriaHidden(mutation.target);
        }
        if (mutation.type === 'childList') {
          normaliseFaqHeadings(mutation.target);
          nameImageOverlayLinks(mutation.target);
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.hasAttribute('aria-hidden')) syncAriaHidden(node);
            node.querySelectorAll && node.querySelectorAll('[aria-hidden="true"], [aria-hidden="false"]').forEach(syncAriaHidden);
          });
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAccessibility, { once: true });
  } else {
    initialiseAccessibility();
  }
})();